export default __webpack_public_path__ + "77fa3edf89f844b492452178f5360eb9.png";